import React from "react";
import {
  ResponsiveContainer,
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
  BarChart, Bar,
} from "recharts";

export function PerformanceChart({ attempts = [] }) {
  const data = [...attempts]
    .sort((a, b) => new Date(a.submitted_at) - new Date(b.submitted_at))
    .map((a, i) => ({
      name: `T${i + 1}`,
      title: a.test_title,
      percent: Math.round(a.percent || 0),
    }));

  if (!data.length) {
    return (
      <div className="h-48 grid place-items-center text-sm text-slate-400">
        No test data yet — your trend line will appear here.
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -10 }}>
        <CartesianGrid stroke="#E2E8F0" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} />
        <YAxis stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} />
        <Tooltip
          contentStyle={{ borderRadius: 8, border: "1px solid #E2E8F0", fontSize: 12 }}
          formatter={(v, _, { payload }) => [`${v}%`, payload.title]}
          labelFormatter={() => ""}
        />
        <Line
          type="monotone"
          dataKey="percent"
          stroke="#2563EB"
          strokeWidth={3}
          dot={{ r: 4, fill: "#2563EB" }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

export function AttendanceBars({ counts = { present: 0, absent: 0, late: 0 } }) {
  const data = [
    { name: "Present", value: counts.present, fill: "#34D399" },
    { name: "Absent", value: counts.absent, fill: "#FB7185" },
    { name: "Late", value: counts.late, fill: "#FBBF24" },
  ];
  const empty = data.every((d) => d.value === 0);
  if (empty) {
    return <div className="h-32 grid place-items-center text-sm text-slate-400">No attendance records yet.</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={180}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
        <CartesianGrid stroke="#E2E8F0" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} />
        <YAxis stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} allowDecimals={false} />
        <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E2E8F0", fontSize: 12 }} />
        <Bar dataKey="value" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
